(() => {
  /* Product share sheet: shared singleton for the standard and Abode galleries.
     It deliberately has no dependency on cart, variant, or gallery internals. */
  const mountProductShare = (root) => {
    if (!root || !root.querySelector('[data-wi-media-stage]')) return;

    if (!window.WIProductShareMount) {
      const sheetCSS = `
        .wi-pg__share-trigger{position:absolute!important;right:16px!important;bottom:16px!important;z-index:8!important;width:46px!important;height:46px!important;min-width:46px!important;min-height:46px!important;display:grid!important;place-items:center!important;padding:0!important;border:1px solid rgba(25,25,25,.12)!important;border-radius:12px!important;background:rgba(255,255,255,.97)!important;color:#191919!important;box-shadow:0 5px 22px rgba(0,0,0,.12)!important;cursor:pointer!important;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);transition:transform .2s ease,box-shadow .2s ease!important}
        .wi-pg__share-trigger:hover{transform:translateY(-2px)!important;box-shadow:0 7px 26px rgba(0,0,0,.17)!important}
        .wi-pg__share-trigger:focus-visible{outline:3px solid var(--wi-pg-accent,#111)!important;outline-offset:2px!important}
        .wi-pg__share-trigger svg{width:23px!important;height:23px!important;display:block!important;fill:none!important;stroke:currentColor!important;stroke-width:1.9!important;stroke-linecap:round!important;stroke-linejoin:round!important}
        .wi-share-layer,.wi-share-layer *{box-sizing:border-box}
        .wi-share-layer[hidden]{display:none!important}
        .wi-share-layer{position:fixed!important;inset:0!important;z-index:2147483000!important;display:flex!important;align-items:flex-end!important;justify-content:center!important;font-family:var(--font-body-family,Arial,sans-serif)!important;color:#1d1d1d!important}
        .wi-share__shade{position:absolute;inset:0;background:rgba(0,0,0,.57);animation:wiShareShade .2s ease}
        .wi-share__panel{position:relative;width:100%;max-width:600px;max-height:min(90dvh,850px);display:flex;flex-direction:column;overflow:hidden;border-radius:22px 22px 0 0;background:#fff;box-shadow:0 -12px 50px rgba(0,0,0,.15);animation:wiShareRise .28s cubic-bezier(.2,.8,.2,1)}
        .wi-share__handle{display:block;align-self:center;width:39px;height:4px;flex:0 0 4px;margin:12px 0 2px;border-radius:20px;background:#d4d4d4}
        .wi-share__header{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:15px 20px 13px}
        .wi-share__heading{margin:0!important;font-size:18px!important;font-weight:750!important;line-height:1.25!important;letter-spacing:-.02em!important;color:#161616!important}
        .wi-share__close{flex:0 0 36px;width:36px;height:36px;display:grid;place-items:center;border:1px solid #e7e7e7;border-radius:50%;background:#fff;color:#333;cursor:pointer}
        .wi-share__close svg{width:18px;height:18px;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;fill:none}
        .wi-share__body{overflow-y:auto;overscroll-behavior:contain;padding:0 20px max(24px,env(safe-area-inset-bottom))}
        .wi-share__preview{display:flex;align-items:center;gap:15px;min-height:124px;padding:15px;margin:8px 0 24px;border:1px solid #e6e6e6;border-radius:14px;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.035)}
        .wi-share__image{flex:0 0 98px;width:98px;height:98px;object-fit:contain;background:#fafafa;border-radius:9px}
        .wi-share__image[hidden]{display:none!important}
        .wi-share__details{min-width:0;display:flex;flex-direction:column;align-items:flex-start;gap:8px}
        .wi-share__name{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;margin:0!important;color:#202020!important;font-size:14px!important;font-weight:700!important;line-height:1.4!important}
        .wi-share__price{font-size:15px;font-weight:750;color:#171717}
        .wi-share__domain{max-width:100%;overflow:hidden;color:#717171;font-size:11px;text-overflow:ellipsis;white-space:nowrap}
        .wi-share__label{display:block;margin-bottom:15px;color:#555;font-size:11px;font-weight:750;letter-spacing:.09em;text-transform:uppercase}
        .wi-share__grid{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));column-gap:8px;row-gap:20px;margin-bottom:20px}
        .wi-share__option{appearance:none;min-width:0;display:flex;flex-direction:column;align-items:center;gap:8px;padding:0!important;border:0!important;background:transparent!important;color:#222!important;cursor:pointer!important;text-align:center!important;text-decoration:none!important}
        .wi-share__option:focus-visible{outline:2px solid #272727!important;outline-offset:5px!important;border-radius:8px!important}
        .wi-share__icon{width:52px;height:52px;display:grid;place-items:center;border:1px solid rgba(0,0,0,.08);border-radius:15px;color:#fff;font-size:32px;font-family:Arial,sans-serif;font-weight:750;line-height:1}
        .wi-share__icon svg{width:29px;height:29px;display:block;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
        .wi-share__icon--whatsapp{background:#22ce5a}
        .wi-share__icon--messenger{background:linear-gradient(140deg,#0099ff,#a23bf0,#ff5b73)}
        .wi-share__icon--pinterest{background:#ce1029;font-family:Georgia,serif;font-style:italic}
        .wi-share__icon--telegram{background:#25a3df}
        .wi-share__icon--snapchat{background:#fffc00;color:#151515}
        .wi-share__icon--messages{background:#33cb63}
        .wi-share__icon--email,.wi-share__icon--copy,.wi-share__icon--more{background:#fff;color:#191919;border-color:#dedede}
        .wi-share__option-label{width:100%;overflow-wrap:anywhere;color:#252525;font-size:11px;font-weight:500;line-height:1.25}
        .wi-share__feedback{min-height:18px;margin:0!important;color:#3d7442;font-size:12px;line-height:1.4}
        @keyframes wiShareShade{from{opacity:0}to{opacity:1}}
        @keyframes wiShareRise{from{opacity:.75;transform:translateY(22px)}to{opacity:1;transform:translateY(0)}}
        @media(min-width:750px){.wi-share-layer{align-items:center!important;padding:30px!important}.wi-share__panel{max-height:min(85vh,760px);border-radius:20px}.wi-share__handle{display:none}.wi-share__header{padding-top:22px}.wi-share__body{padding-bottom:24px}}
        @media(max-width:390px){.wi-share__header{padding-inline:16px}.wi-share__body{padding-inline:16px}.wi-share__grid{gap:16px 4px}.wi-share__icon{width:46px;height:46px;border-radius:14px}.wi-share__option-label{font-size:10px}.wi-share__preview{gap:12px;padding:11px}.wi-share__image{flex-basis:84px;width:84px;height:84px}}
        @media(prefers-reduced-motion:reduce){.wi-share__shade,.wi-share__panel{animation:none!important}.wi-pg__share-trigger{transition:none!important}}
      `;
      if (!document.getElementById('wi-product-share-style')) {
        const styles = document.createElement('style');
        styles.id = 'wi-product-share-style';
        styles.textContent = sheetCSS;
        document.head.appendChild(styles);
      }

      const overlay = document.createElement('div');
      overlay.className = 'wi-share-layer';
      overlay.hidden = true;
      overlay.innerHTML = `
        <div class="wi-share__shade" data-wi-share-dismiss></div>
        <section class="wi-share__panel" role="dialog" aria-modal="true" aria-labelledby="wi-share-heading" tabindex="-1">
          <span class="wi-share__handle" aria-hidden="true"></span>
          <div class="wi-share__header">
            <h2 class="wi-share__heading" id="wi-share-heading">Share this product with friends</h2>
            <button class="wi-share__close" type="button" data-wi-share-dismiss aria-label="Close sharing options"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5 19 19M19 5 5 19"/></svg></button>
          </div>
          <div class="wi-share__body">
            <div class="wi-share__preview">
              <img class="wi-share__image" data-wi-share-image alt="" width="98" height="98" loading="lazy">
              <div class="wi-share__details"><strong class="wi-share__name" data-wi-share-title></strong><span class="wi-share__price" data-wi-share-price></span><span class="wi-share__domain" data-wi-share-domain></span></div>
            </div>
            <span class="wi-share__label">Share via</span>
            <div class="wi-share__grid" role="group" aria-label="Sharing platforms">
              <button class="wi-share__option" type="button" data-wi-share-service="whatsapp"><span class="wi-share__icon wi-share__icon--whatsapp" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M16 4a12 12 0 0 0-10.2 18.3L4 28l5.9-1.7A12 12 0 1 0 16 4Z"/><path d="M11.2 10.3c-.5-.6-1.2-.4-1.6.2-1 1.3-.5 3.3 1.8 5.8 2.4 2.5 4.9 4 7.7 4.2 1.3.1 2.7-1 2.6-2.2l-3.1-1.5-1.4 1.5c-1.7-.6-3.2-1.8-4.2-3.3l1.1-1.5Z"/></svg></span><span class="wi-share__option-label">WhatsApp</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="messenger"><span class="wi-share__icon wi-share__icon--messenger" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M16 5C8.8 5 4 9.8 4 16.1c0 3.2 1.4 5.9 4 7.8V28l4.2-2.3c1.2.4 2.5.6 3.8.6 7.1 0 12-4.8 12-11.1S23.1 5 16 5Z"/><path d="m8.5 19.5 6.1-6.4 3.5 3.3 5.4-3.3-6.1 6.4-3.4-3.3Z"/></svg></span><span class="wi-share__option-label">Messenger</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="pinterest"><span class="wi-share__icon wi-share__icon--pinterest" aria-hidden="true">P</span><span class="wi-share__option-label">Pinterest</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="telegram"><span class="wi-share__icon wi-share__icon--telegram" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="m4 14 23-9-6 22-6-8-5 4 1-7 11-8-15 10Z" fill="currentColor" stroke="none"/></svg></span><span class="wi-share__option-label">Telegram</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="snapchat"><span class="wi-share__icon wi-share__icon--snapchat" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M16 5c-4.1 0-6.4 3.2-6.2 7.6l-2 1.1c-1.6-.3-2.5.6-1.5 1.5l3.8 2.1c-.4 3-2 4.2-4.5 5.1.9 1.5 2.6 1.6 4.3 1.9l1.4 2.4 4.7-1.1 4.7 1.1 1.4-2.4c1.7-.3 3.4-.4 4.3-1.9-2.5-.9-4.1-2.1-4.5-5.1l3.8-2.1c1-.9.1-1.8-1.5-1.5l-2-1.1C22.4 8.2 20.1 5 16 5Z"/></svg></span><span class="wi-share__option-label">Snapchat</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="messages"><span class="wi-share__icon wi-share__icon--messages" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M5 7h22v16H13l-7 5v-5H5Z" fill="currentColor" stroke="none"/></svg></span><span class="wi-share__option-label">Messages</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="email"><span class="wi-share__icon wi-share__icon--email" aria-hidden="true"><svg viewBox="0 0 32 32"><rect x="4" y="8" width="24" height="17" rx="3"/><path d="m5 10 11 9 11-9"/></svg></span><span class="wi-share__option-label">Email</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="copy"><span class="wi-share__icon wi-share__icon--copy" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M12 11h-2a7 7 0 0 0 0 14h5a7 7 0 0 0 6.4-4M20 21h2a7 7 0 0 0 0-14h-5a7 7 0 0 0-6.4 4M12 16h8"/></svg></span><span class="wi-share__option-label">Copy link</span></button>
              <button class="wi-share__option" type="button" data-wi-share-service="more"><span class="wi-share__icon wi-share__icon--more" aria-hidden="true"><svg viewBox="0 0 32 32"><circle cx="7" cy="16" r="2" fill="currentColor" stroke="none"/><circle cx="16" cy="16" r="2" fill="currentColor" stroke="none"/><circle cx="25" cy="16" r="2" fill="currentColor" stroke="none"/></svg></span><span class="wi-share__option-label">More</span></button>
            </div>
            <p class="wi-share__feedback" data-wi-share-feedback role="status" aria-live="polite"></p>
          </div>
        </section>`;
      document.body.appendChild(overlay);

      let previousFocus = null;
      let activePayload = null;
      let originalBodyOverflow = '';
      let originalHtmlOverflow = '';
      const panel = overlay.querySelector('.wi-share__panel');
      const feedback = overlay.querySelector('[data-wi-share-feedback]');

      const close = () => {
        if (overlay.hidden) return;
        overlay.hidden = true;
        document.body.style.overflow = originalBodyOverflow;
        document.documentElement.style.overflow = originalHtmlOverflow;
        activePayload = null;
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
        previousFocus = null;
      };

      const open = (trigger) => {
        const gallery = trigger.closest('[data-wi-product-gallery]');
        if (!gallery) return;
        const title = gallery.querySelector('.wi-pg__product-title, [data-wi-product-title], h1')?.textContent?.replace(/\s+/g, ' ').trim() || document.title;
        const activeMedia = gallery.querySelector('[data-wi-media].is-active');
        const image = activeMedia?.querySelector('img.wi-pg__main-image, img') || gallery.querySelector('.wi-pg__main-image, [data-wi-media] img');
        const imageUrl = image?.currentSrc || image?.src || activeMedia?.querySelector('video')?.poster || '';
        const price = gallery.querySelector('[data-wi-price]')?.textContent?.trim() || '';
        let url = gallery.dataset.wiShareUrl || document.querySelector('link[rel="canonical"]')?.href || window.location.href;
        try {
          const parsed = new URL(url, window.location.origin);
          // Share the public product URL, not tracking parameters or a Shopify editor preview URL.
          ['_pos','_sid','_ss','utm_source','utm_medium','utm_campaign','utm_content','utm_term','preview_theme_id'].forEach((key) => parsed.searchParams.delete(key));
          const chosenVariant = gallery.querySelector('[data-wi-active-variant]')?.value || gallery.querySelector('[data-wi-mode-panel]:not([hidden]) [data-wi-variant]')?.value || gallery.querySelector('[data-wi-variant]')?.value;
          if (/\/products\//.test(parsed.pathname) && /^\d+$/.test(chosenVariant || '')) {
            parsed.searchParams.set('variant', chosenVariant);
          }
          url = parsed.href;
        } catch (error) {
          url = window.location.href;
        }
        activePayload = { title, url, imageUrl };
        overlay.querySelector('[data-wi-share-title]').textContent = title;
        overlay.querySelector('[data-wi-share-price]').textContent = price;
        overlay.querySelector('[data-wi-share-price]').hidden = !price;
        const preview = overlay.querySelector('[data-wi-share-image]');
        preview.hidden = !imageUrl;
        if (imageUrl) { preview.src = imageUrl; preview.alt = title; }
        overlay.querySelector('[data-wi-share-domain]').textContent = new URL(url, location.href).hostname;
        feedback.textContent = '';
        previousFocus = trigger;
        originalBodyOverflow = document.body.style.overflow;
        originalHtmlOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        overlay.hidden = false;
        overlay.querySelector('.wi-share__close').focus({ preventScroll: true });
      };

      const copyLink = async (url) => {
        try {
          if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(url); return true; }
        } catch (error) { /* Older iOS browsers require the fallback below. */ }
        const input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
        document.body.appendChild(input);
        input.focus();
        input.select();
        let success = false;
        try { success = document.execCommand('copy'); } catch (error) { /* Unsupported browser. */ }
        input.remove();
        return success;
      };

      const nativeShare = async () => {
        const payload = activePayload;
        if (!payload) return;
        if (typeof navigator.share !== 'function') {
          feedback.textContent = (await copyLink(payload.url)) ? 'Link copied. Paste it into your preferred app.' : 'Use Copy link to share this product.';
          return;
        }
        close();
        try { await navigator.share({ title: payload.title, text: payload.title, url: payload.url }); }
        catch (error) { if (error?.name !== 'AbortError') console.warn('[WI Product Share] Native share unavailable:', error); }
      };

      const shareTo = async (service) => {
        const payload = activePayload;
        if (!payload) return;
        const encodedURL = encodeURIComponent(payload.url);
        const encodedText = encodeURIComponent(`${payload.title} ${payload.url}`);
        const openLink = (url) => {
          close();
          const tab = window.open(url, '_blank');
          if (tab) tab.opener = null;
          else window.location.assign(url);
        };
        if (service === 'whatsapp') return openLink(`https://api.whatsapp.com/send?text=${encodedText}`);
        if (service === 'telegram') return openLink(`https://t.me/share/url?url=${encodedURL}&text=${encodeURIComponent(payload.title)}`);
        if (service === 'pinterest') return openLink(`https://www.pinterest.com/pin/create/button/?url=${encodedURL}&media=${encodeURIComponent(payload.imageUrl)}&description=${encodeURIComponent(payload.title)}`);
        if (service === 'email') {
          close();
          window.location.href = `mailto:?subject=${encodeURIComponent(payload.title)}&body=${encodedText}`;
          return;
        }
        if (service === 'messages') {
          close();
          const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
          window.location.href = `sms:${ios ? '&' : '?'}body=${encodedText}`;
          return;
        }
        if (service === 'copy') {
          feedback.textContent = (await copyLink(payload.url)) ? 'Product link copied!' : 'Unable to copy automatically. Please copy the page URL.';
          return;
        }
        // Browsers cannot open a Messenger/Snapchat compose screen with a URL
        // reliably without their native app integrations. Use the OS share sheet.
        if (service === 'messenger' || service === 'snapchat' || service === 'more') {
          if (typeof navigator.share === 'function') return nativeShare();
          const copied = await copyLink(payload.url);
          feedback.textContent = copied
            ? (service === 'more' ? 'Product link copied. Paste it into any app.' : `Product link copied. Open ${service === 'messenger' ? 'Messenger' : 'Snapchat'} and paste the link.`)
            : 'Sharing is unavailable here. Try Copy link.';
        }
      };

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest?.('[data-wi-product-share-open]');
        if (trigger) { event.preventDefault(); event.stopPropagation(); open(trigger); return; }
        if (overlay.hidden) return;
        if (event.target.closest?.('[data-wi-share-dismiss]')) { close(); return; }
        const action = event.target.closest?.('[data-wi-share-service]');
        if (action && overlay.contains(action)) { event.preventDefault(); void shareTo(action.dataset.wiShareService); }
      });

      document.addEventListener('keydown', (event) => {
        if (overlay.hidden) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); return; }
        if (event.key !== 'Tab') return;
        const controls = [...panel.querySelectorAll('button:not([disabled])')].filter((button) => button.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if (!first || !last) return;
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });

      window.WIProductShareMount = (gallery) => {
        const stage = gallery?.querySelector('[data-wi-media-stage]');
        if (!stage || stage.querySelector('[data-wi-product-share-open]')) return;
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'wi-pg__share-trigger';
        trigger.setAttribute('data-wi-product-share-open', '');
        trigger.setAttribute('aria-label', 'Share this product');
        trigger.setAttribute('title', 'Share this product');
        trigger.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V3m-5 5 5-5 5 5"/><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>';
        stage.appendChild(trigger);
      };
    }

    window.WIProductShareMount(root);
  };

  if (window.__wiProductGalleryAssetLoaded) {
    document
      .querySelectorAll('[data-wi-product-gallery]')
      .forEach((root) => window.WIProductGalleryInitialize?.(root));
    return;
  }

  window.__wiProductGalleryAssetLoaded = true;

  const initialize = (root) => {
    if (!root || root.dataset.wiReady === 'true') return;

    root.dataset.wiReady = 'true';

    mountProductShare(root);

    const configElement = root.querySelector('[data-wi-product-config]');
    let config = {};

    try {
      config = JSON.parse(configElement?.textContent || '{}');
    } catch (error) {
      console.error(
        '[WI Product Gallery] Invalid configuration JSON.',
        error
      );
    }

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion:reduce)'
    ).matches;

    const moneyFormat = config.moneyFormat || '${{amount}}';
    const locale =
      config.locale || document.documentElement.lang || 'en-IN';

    const currency =
      config.currency ||
      window.Shopify?.currency?.active ||
      'INR';

    const formatMoney = (cents) =>
      window.Shopify?.formatMoney
        ? window.Shopify.formatMoney(cents, moneyFormat)
        : new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
          }).format(Number(cents || 0) / 100);

    const stickySlot = root.querySelector(
      '[data-wi-sticky-slot]'
    );

    const sticky = root.querySelector('[data-wi-sticky]');

    const stickyMode =
      root.dataset.wiStickyMode || 'automatic';

    const stickyGap = Number(
      root.dataset.wiStickyGap || 0
    );

    const stickyZ = Number(
      root.dataset.wiStickyZ || 1200
    );

    const nav = sticky?.querySelector('.wi-pg__nav');

    const indicator = sticky?.querySelector(
      '[data-wi-indicator]'
    );

    const navButtons = Array.from(
      sticky?.querySelectorAll('[data-wi-target-part]') || []
    );

    const productForm = root.querySelector(
      'form[action*="/cart/add"]'
    );

    const primarySubmit = productForm?.querySelector(
      '[name="add"]'
    );

    const primarySubmitLabel = primarySubmit?.querySelector(
      'span:first-child'
    );

    const stickySubmitButtons = Array.from(
      root.querySelectorAll('[data-wi-submit-form]')
    );

    const productInfo = root.querySelector(
      '[data-wi-product-info]'
    );

    const shopRoot = window.Shopify?.routes?.root || '/';
    const cartAddUrl = `${shopRoot}cart/add.js`;
    const cartUrl = `${shopRoot}cart.js`;

    let stickyCartBusy = false;
    let stickyCartResetTimer = null;

    const headerSelector = [
      '[data-wi-header]',
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      'sticky-header',
      'header.header-wrapper',
      '.header-wrapper',
      'header.site-header',
      'header[role="banner"]',
      '[data-sticky-header]'
    ].join(',');

    let headerCandidates = [];
    let productPartMap = new Map();
    let targets = [];
    let activePart = 'images';
    let navigationFrame = null;
    let indicatorFrame = null;
    let pendingIndicatorButton = null;
    let navigationLockPart = null;
    let navigationLockTimer = null;
    let lastFixed = null;
    let lastStickyTop = null;
    let lastStickyZ = null;

    const refreshHeaderCandidates = () => {
      headerCandidates = Array.from(
        document.querySelectorAll(headerSelector)
      )
        .filter(
          (element) =>
            !root.contains(element) && element !== sticky
        )
        .map((element) => {
          const z = parseInt(
            getComputedStyle(element).zIndex,
            10
          );

          return {
            element,
            z: Number.isFinite(z) ? z : 0
          };
        });
    };

    const refreshTargets = () => {
      productPartMap = new Map(
        Array.from(
          document.querySelectorAll('[data-wi-product-part]')
        ).map((element) => [
          element.dataset.wiProductPart,
          element
        ])
      );

      targets = [];

      navButtons.forEach((button) => {
        const part = button.dataset.wiTargetPart;
        const target = productPartMap.get(part);

        button.hidden = !target;

        if (target) {
          targets.push({
            part,
            element: target
          });
        }
      });

      if (
        !targets.some(
          (target) => target.part === activePart
        ) &&
        targets.length
      ) {
        activePart = targets[0].part;
      }
    };

    const refreshStructure = () => {
      refreshHeaderCandidates();
      refreshTargets();
    };

    const getHeaderMetrics = () => {
      const manual = Math.max(
        0,
        parseFloat(
          getComputedStyle(root).getPropertyValue(
            '--wi-pg-top'
          )
        ) || 0
      );

      if (stickyMode !== 'automatic') {
        return {
          top: manual,
          z: stickyZ
        };
      }

      let bottom = manual;
      let headerZ = 0;

      headerCandidates.forEach(({ element, z }) => {
        if (!element.isConnected) return;

        const rect = element.getBoundingClientRect();

        if (
          rect.top > 40 ||
          rect.bottom <= 0 ||
          rect.height < 2 ||
          rect.height > 400
        ) {
          return;
        }

        bottom = Math.max(bottom, rect.bottom);
        headerZ = Math.max(headerZ, z);
      });

      return {
        top: Math.max(0, bottom + stickyGap),
        z:
          headerZ > 1
            ? Math.max(
                20,
                Math.min(stickyZ, headerZ - 1)
              )
            : stickyZ
      };
    };

    const positionIndicator = (button) => {
      if (!nav || !indicator || !button) return;

      const navRect = nav.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();

      const inset = Math.min(
        16,
        Math.max(9, buttonRect.width * 0.17)
      );

      const nextX = (
        buttonRect.left -
        navRect.left +
        nav.scrollLeft +
        inset
      ).toFixed(2);

      const nextWidth = Math.max(
        20,
        buttonRect.width - inset * 2
      ).toFixed(2);

      if (indicator.dataset.x !== nextX) {
        indicator.style.transform =
          `translate3d(${nextX}px,0,0)`;

        indicator.dataset.x = nextX;
      }

      if (indicator.dataset.width !== nextWidth) {
        indicator.style.width = `${nextWidth}px`;
        indicator.dataset.width = nextWidth;
      }

      indicator.classList.add('is-ready');
    };

    const requestIndicator = (button) => {
      pendingIndicatorButton = button;

      if (indicatorFrame !== null) return;

      indicatorFrame = requestAnimationFrame(() => {
        indicatorFrame = null;

        positionIndicator(pendingIndicatorButton);

        pendingIndicatorButton = null;
      });
    };

    const keepActiveTabVisible = (button) => {
      if (
        !nav ||
        !button ||
        nav.scrollWidth <= nav.clientWidth + 1
      ) {
        return;
      }

      const buttonLeft = button.offsetLeft;
      const buttonRight =
        buttonLeft + button.offsetWidth;

      const visibleLeft = nav.scrollLeft + 14;
      const visibleRight =
        nav.scrollLeft + nav.clientWidth - 14;

      if (
        buttonLeft >= visibleLeft &&
        buttonRight <= visibleRight
      ) {
        return;
      }

      const nextLeft =
        buttonLeft -
        (nav.clientWidth - button.offsetWidth) / 2;

      nav.scrollTo({
        left: Math.max(0, nextLeft),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    };

    const setActive = (part, force = false) => {
      const button = navButtons.find(
        (item) =>
          item.dataset.wiTargetPart === part &&
          !item.hidden
      );

      if (!button) return false;

      const didChange =
        force ||
        activePart !== part ||
        !button.classList.contains('is-active');

      activePart = part;

      if (didChange) {
        navButtons.forEach((item) => {
          const active = item === button;

          item.classList.toggle(
            'is-active',
            active
          );

          if (active) {
            item.setAttribute(
              'aria-current',
              'location'
            );
          } else {
            item.removeAttribute('aria-current');
          }
        });

        keepActiveTabVisible(button);
      }

      requestIndicator(button);

      return true;
    };

    const applyStickyState = (
      shouldFix,
      metrics
    ) => {
      if (!sticky) return;

      if (lastFixed !== shouldFix) {
        sticky.classList.toggle(
          'is-fixed',
          shouldFix
        );

        lastFixed = shouldFix;
      }

      if (shouldFix) {
        if (lastStickyTop !== metrics.top) {
          sticky.style.setProperty(
            'top',
            `${metrics.top}px`,
            'important'
          );

          lastStickyTop = metrics.top;
        }

        if (lastStickyZ !== metrics.z) {
          sticky.style.setProperty(
            'z-index',
            String(metrics.z),
            'important'
          );

          lastStickyZ = metrics.z;
        }
      } else if (
        lastStickyTop !== null ||
        lastStickyZ !== null
      ) {
        sticky.style.removeProperty('top');
        sticky.style.removeProperty('z-index');

        lastStickyTop = null;
        lastStickyZ = null;
      }
    };

    const releaseNavigationLock = (
      refresh = true
    ) => {
      navigationLockPart = null;

      if (navigationLockTimer !== null) {
        clearTimeout(navigationLockTimer);
      }

      navigationLockTimer = null;

      if (refresh) {
        requestNavigationUpdate();
      }
    };

    const lockNavigationTo = (part) => {
      navigationLockPart = part;

      if (navigationLockTimer !== null) {
        clearTimeout(navigationLockTimer);
      }

      navigationLockTimer = setTimeout(
        () => releaseNavigationLock(),
        1600
      );
    };

    const updateNavigation = () => {
      navigationFrame = null;

      if (!stickySlot || !sticky) return;

      const metrics = getHeaderMetrics();
      const stickyHeight = sticky.offsetHeight;

      const marker =
        metrics.top + stickyHeight + 24;

      const slotTop =
        stickySlot.getBoundingClientRect().top;

      const rootBottom =
        root.getBoundingClientRect().bottom;

      const targetRects = targets.map(
        (target) => ({
          ...target,
          rect: target.element.getBoundingClientRect()
        })
      );

      const groupBottom = targetRects.reduce(
        (bottom, target) =>
          Math.max(bottom, target.rect.bottom),
        rootBottom
      );

      const shouldFix =
        slotTop <= metrics.top &&
        groupBottom >
          metrics.top + stickyHeight;

      let nextActive =
        targetRects[0]?.part || activePart;

      if (navigationLockPart) {
        const locked = targetRects.find(
          (target) =>
            target.part === navigationLockPart
        );

        const lockedOffset =
          metrics.top + stickyHeight + 12;

        if (
          locked &&
          Math.abs(
            locked.rect.top - lockedOffset
          ) > 4
        ) {
          nextActive = navigationLockPart;
        } else {
          releaseNavigationLock(false);
        }
      }

      if (!navigationLockPart) {
        targetRects.forEach((target) => {
          if (target.rect.top <= marker) {
            nextActive = target.part;
          }
        });

        if (
          window.scrollY + window.innerHeight >=
            document.documentElement.scrollHeight - 4 &&
          targetRects.length
        ) {
          nextActive =
            targetRects[targetRects.length - 1].part;
        }
      }

      applyStickyState(shouldFix, metrics);
      setActive(nextActive);
    };

    const requestNavigationUpdate = () => {
      if (navigationFrame !== null) return;

      navigationFrame =
        requestAnimationFrame(updateNavigation);
    };

    const findPart = (part) =>
      productPartMap.get(part) ||
      document.querySelector(
        `[data-wi-product-part="${part}"]`
      );

    const scrollToElement = (target) => {
      if (!target) return;

      const metrics = getHeaderMetrics();

      const offset =
        metrics.top +
        (sticky?.offsetHeight || 0) +
        12;

      window.scrollTo({
        top: Math.max(
          0,
          window.scrollY +
            target.getBoundingClientRect().top -
            offset
        ),
        behavior: reducedMotion
          ? 'auto'
          : 'smooth'
      });
    };

    const handlePartClick = (button) => {
      const part = button.dataset.wiTargetPart;
      const target = findPart(part);

      if (!target) return;

      setActive(part, true);
      lockNavigationTo(part);
      scrollToElement(target);
    };

    const setStickyCartState = (
      state,
      message
    ) => {
      stickySubmitButtons.forEach((button) => {
        const label = button.querySelector(
          '[data-wi-submit-label]'
        );

        if (!button.dataset.wiDefaultLabel) {
          button.dataset.wiDefaultLabel =
            label?.textContent?.trim() ||
            button.textContent.trim();
        }

        button.classList.toggle(
          'wi-state-loading',
          state === 'loading'
        );

        button.classList.toggle(
          'wi-state-success',
          state === 'success'
        );

        button.classList.toggle(
          'wi-state-error',
          state === 'error'
        );

        button.setAttribute(
          'aria-busy',
          state === 'loading'
            ? 'true'
            : 'false'
        );

        button.disabled = state === 'loading';

        if (label) {
          label.textContent =
            message ||
            button.dataset.wiDefaultLabel;
        }
      });

      if (primarySubmit) {
        if (!primarySubmit.dataset.wiDefaultLabel) {
          primarySubmit.dataset.wiDefaultLabel =
            primarySubmitLabel?.textContent?.trim() ||
            primarySubmit.textContent.trim();
        }

        primarySubmit.classList.toggle(
          'wi-state-loading',
          state === 'loading'
        );

        primarySubmit.classList.toggle(
          'wi-state-success',
          state === 'success'
        );

        primarySubmit.classList.toggle(
          'wi-state-error',
          state === 'error'
        );

        primarySubmit.setAttribute(
          'aria-busy',
          state === 'loading'
            ? 'true'
            : 'false'
        );

        primarySubmit.disabled = state === 'loading';

        if (primarySubmitLabel) {
          primarySubmitLabel.textContent =
            message ||
            primarySubmit.dataset.wiDefaultLabel;
        }
      }
    };

    const scheduleStickyCartReset = (
      delay = 1400
    ) => {
      if (stickyCartResetTimer !== null) {
        clearTimeout(stickyCartResetTimer);
      }

      stickyCartResetTimer = setTimeout(() => {
        setStickyCartState('idle');
        stickyCartResetTimer = null;
      }, delay);
    };

    const getCartRenderer = () =>
      document.querySelector('cart-drawer') ||
      document.querySelector(
        'cart-notification'
      );

    const getRequestedCartSections = (
      renderer
    ) => {
      const fromRenderer =
        typeof renderer?.getSectionsToRender ===
        'function'
          ? renderer
              .getSectionsToRender()
              .map((section) => section.id)
              .filter(Boolean)
          : [];

      return [
        ...new Set(
          fromRenderer.length
            ? fromRenderer
            : [
                'cart-drawer',
                'cart-icon-bubble'
              ]
        )
      ];
    };

    const cartCountSelector = [
      '.wi-header__cart-count',
      '[data-cart-count]',
      '[data-header-cart-count]',
      '[data-js-cart-count]',
      '.header__cart-count',
      '.site-header__cart-count',
      '.menu-meta__count',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span:first-child'
    ].join(',');

    const normaliseCartCount = (value) =>
      Math.max(
        0,
        parseInt(value, 10) || 0
      );

    const ensureCustomHeaderCartCount = (
      count
    ) => {
      const nodes = [];

      document
        .querySelectorAll(
          '.wi-header__icon-link--cart'
        )
        .forEach((link) => {
          let badge = link.querySelector(
            '.wi-header__cart-count'
          );

          if (!badge && count > 0) {
            badge = document.createElement('span');

            badge.className =
              'wi-header__cart-count';

            badge.setAttribute(
              'aria-live',
              'polite'
            );

            link.appendChild(badge);
          }

          if (badge) {
            nodes.push(badge);
          }
        });

      return nodes;
    };

    const updateCartCountDisplay = (
      value
    ) => {
      const count =
        normaliseCartCount(value);

      const nodes = Array.from(
        document.querySelectorAll(
          cartCountSelector
        )
      );

      ensureCustomHeaderCartCount(
        count
      ).forEach((node) => {
        if (!nodes.includes(node)) {
          nodes.push(node);
        }
      });

      nodes.forEach((node) => {
        node.textContent =
          count > 99 ? '99+' : String(count);

        node.setAttribute(
          'data-count',
          String(count)
        );

        node.hidden = count === 0;

        node.classList.toggle(
          'hidden',
          count === 0
        );

        node.classList.toggle(
          'hide',
          count === 0
        );
      });

      document
        .querySelectorAll('.cart-count-bubble')
        .forEach((bubble) => {
          bubble.hidden = count === 0;

          bubble.classList.toggle(
            'hidden',
            count === 0
          );

          bubble.classList.toggle(
            'hide',
            count === 0
          );
        });
    };

    const readDisplayedCartCount = () => {
      const node = document.querySelector(
        [
          '.wi-header__cart-count',
          '[data-cart-count]',
          '.header__cart-count',
          '.site-header__cart-count',
          '.cart-count-bubble span[aria-hidden="true"]'
        ].join(',')
      );

      if (!node) return null;

      const count = parseInt(
        node.textContent,
        10
      );

      return Number.isFinite(count)
        ? count
        : null;
    };

    const updateFallbackCartCount =
      async () => {
        try {
          const response = await fetch(
            cartUrl,
            {
              method: 'GET',
              credentials: 'same-origin',
              cache: 'no-store',
              headers: {
                Accept: 'application/json'
              }
            }
          );

          if (!response.ok) return null;

          const cart = await response.json();

          updateCartCountDisplay(
            cart.item_count
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart,
                source: 'wi-sticky-cart'
              }
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                cart,
                source: 'wi-sticky-cart'
              }
            })
          );

          return cart;
        } catch (error) {
          console.warn(
            '[WI Product Gallery] Cart count refresh failed.',
            error
          );

          return null;
        }
      };

    const submitProductForm = async (
      event,
      trigger = null
    ) => {
      event?.preventDefault();

      const submitter =
        trigger ||
        event?.submitter ||
        document.activeElement ||
        primarySubmit;

      if (
        stickyCartBusy ||
        !productForm ||
        !primarySubmit
      ) {
        return;
      }

      if (primarySubmit.disabled) {
        scrollToElement(
          root.querySelector(
            '[data-wi-variant-picker]'
          ) ||
            productInfo ||
            productForm
        );

        return;
      }

      stickyCartBusy = true;

      setStickyCartState(
        'loading',
        'Adding…'
      );

      const formData =
        new FormData(productForm);

      const cartRenderer =
        getCartRenderer();

      const requestedSections =
        getRequestedCartSections(
          cartRenderer
        );

      if (
        typeof cartRenderer?.setActiveElement ===
        'function'
      ) {
        cartRenderer.setActiveElement(
          submitter
        );
      }

      const previousCartCount =
        readDisplayedCartCount();

      const requestedQuantity = Math.max(
        1,
        parseInt(
          formData.get('quantity'),
          10
        ) || 1
      );

      const optimisticCartCount =
        previousCartCount === null
          ? null
          : previousCartCount +
            requestedQuantity;

      if (
        optimisticCartCount !== null
      ) {
        updateCartCountDisplay(
          optimisticCartCount
        );
      }

      formData.set(
        'sections',
        requestedSections.join(',')
      );

      formData.set(
        'sections_url',
        window.location.pathname
      );

      try {
        const response = await fetch(
          cartAddUrl,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            },
            body: formData
          }
        );

        const result =
          await response.json();

        if (
          !response.ok ||
          result.status
        ) {
          throw new Error(
            result.description ||
              result.message ||
              'Unable to add this product to the cart.'
          );
        }

        if (
          typeof cartRenderer?.renderContents ===
          'function'
        ) {
          cartRenderer.renderContents(
            result
          );
        }

        if (
          cartRenderer?.tagName ===
            'CART-DRAWER' &&
          typeof cartRenderer.open ===
            'function'
        ) {
          window.requestAnimationFrame(() => {
            cartRenderer.open(
              submitter
            );
          });
        }

        updateFallbackCartCount();

        document.dispatchEvent(
          new CustomEvent(
            'wi:cart-item-added',
            {
              bubbles: true,
              detail: {
                item: result,
                source: 'wi-product-page'
              }
            }
          )
        );

        setStickyCartState(
          'success',
          'Added ✓'
        );

        scheduleStickyCartReset(1400);
      } catch (error) {
        if (
          previousCartCount !== null
        ) {
          updateCartCountDisplay(
            previousCartCount
          );
        }

        console.error(
          '[WI Product Gallery] Sticky add to cart failed.',
          error
        );

        setStickyCartState(
          'error',
          'Try again'
        );

        scheduleStickyCartReset(1900);
      } finally {
        stickyCartBusy = false;
      }
    };

    navButtons.forEach((button) =>
      button.addEventListener(
        'click',
        () => handlePartClick(button)
      )
    );

    root
      .querySelectorAll(
        '[data-wi-target-part]'
      )
      .forEach((button) => {
        if (navButtons.includes(button)) {
          return;
        }

        button.addEventListener(
          'click',
          () => handlePartClick(button)
        );
      });

    productForm?.addEventListener(
      'submit',
      submitProductForm
    );

    const handleStickySubmitClick = (
      event
    ) => {
      const button =
        event.target.closest?.(
          '[data-wi-submit-form]'
        );

      if (
        !button ||
        !root.contains(button)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      submitProductForm(
        event,
        button
      );
    };

    root.addEventListener(
      'click',
      handleStickySubmitClick,
      true
    );

    const handleNavigationResize = () => {
      refreshHeaderCandidates();

      requestIndicator(
        navButtons.find((button) =>
          button.classList.contains(
            'is-active'
          )
        )
      );

      requestNavigationUpdate();
    };

    const handleManualNavigation = () => {
      if (navigationLockPart) {
        releaseNavigationLock();
      }
    };

    const handleNavigationKey = (
      event
    ) => {
      if (
        [
          'PageUp',
          'PageDown',
          'Home',
          'End',
          'ArrowUp',
          'ArrowDown',
          ' '
        ].includes(event.key)
      ) {
        handleManualNavigation();
      }
    };

    const handleScrollEnd = () =>
      releaseNavigationLock();

    const handleSectionStructureChange =
      () => {
        refreshStructure();
        setActive(activePart, true);
        requestNavigationUpdate();
      };

    window.addEventListener(
      'scroll',
      requestNavigationUpdate,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      handleNavigationResize
    );

    window.addEventListener(
      'scrollend',
      handleScrollEnd
    );

    window.addEventListener(
      'wheel',
      handleManualNavigation,
      {
        passive: true
      }
    );

    window.addEventListener(
      'touchstart',
      handleManualNavigation,
      {
        passive: true
      }
    );

    window.addEventListener(
      'keydown',
      handleNavigationKey
    );

    document.addEventListener(
      'shopify:section:load',
      handleSectionStructureChange
    );

    document.addEventListener(
      'shopify:section:unload',
      handleSectionStructureChange
    );

    const startNavigation = () => {
      refreshStructure();
      setActive(activePart, true);
      updateNavigation();
    };

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        startNavigation,
        {
          once: true
        }
      );
    } else {
      startNavigation();
    }

    const syncReviews = (
      source = document.querySelector(
        '[data-wi-product-part="reviews"]'
      )
    ) => {
      if (!source) return;

      root
        .querySelector(
          '[data-wi-rating-value]'
        )
        ?.replaceChildren(
          source.dataset.wiRatingValue || ''
        );

      root
        .querySelector(
          '[data-wi-rating-count]'
        )
        ?.replaceChildren(
          source.dataset.wiRatingCount || ''
        );
    };

    const handleReviewsSummary = (
      event
    ) => {
      syncReviews(event.detail?.target);
    };

    document.addEventListener(
      'wi:reviews-summary',
      handleReviewsSummary
    );

    syncReviews();

    const mediaItems = Array.from(
      root.querySelectorAll(
        '[data-wi-media]'
      )
    );

    const stage = root.querySelector(
      '[data-wi-media-stage]'
    );

    const thumbnails = Array.from(
      root.querySelectorAll(
        '[data-wi-thumbnail]'
      )
    );

    const progress = Array.from(
      root.querySelectorAll(
        '[data-wi-progress]'
      )
    );

    const track = root.querySelector(
      '[data-wi-thumb-track]'
    );

    let activeIndex = Math.max(
      0,
      thumbnails.findIndex((item) =>
        item.classList.contains(
          'is-active'
        )
      )
    );

    const updateThumbArrows = () => {
      if (!track) return;

      const max = Math.max(
        0,
        track.scrollWidth -
          track.clientWidth
      );

      const prev = root.querySelector(
        '[data-wi-thumb-prev]'
      );

      const next = root.querySelector(
        '[data-wi-thumb-next]'
      );

      if (prev) {
        prev.disabled =
          track.scrollLeft <= 1;
      }

      if (next) {
        next.disabled =
          track.scrollLeft >= max - 1;
      }
    };

    const keepThumbnailVisible = (
      thumb
    ) => {
      if (!track || !thumb) return;

      const left = thumb.offsetLeft;
      const right =
        left + thumb.offsetWidth;

      const visibleLeft =
        track.scrollLeft;

      const visibleRight =
        visibleLeft + track.clientWidth;

      if (
        left >= visibleLeft + 2 &&
        right <= visibleRight - 2
      ) {
        return;
      }

      const next =
        left -
        (track.clientWidth -
          thumb.offsetWidth) /
          2;

      track.scrollTo({
        left: Math.max(0, next),
        behavior: reducedMotion
          ? 'auto'
          : 'smooth'
      });
    };

    /* A thumbnail click is a user gesture: explicitly start the selected
       Shopify-hosted video instead of only unhiding its paused <video> tag.
       Keep native playback controls for pause, volume, seeking and fullscreen. */
    const videoMediaItems = mediaItems.filter(
      (item) => item.dataset.mediaType === 'video'
    );

    const setVideoFeedback = (item, message = '') => {
      const feedback = item?.querySelector('[data-wi-video-feedback]');
      if (!feedback) return;
      feedback.textContent = message;
      feedback.hidden = !message;
    };

    const syncVideoPlayButton = (item) => {
      const video = item?.querySelector('video');
      const button = item?.querySelector('[data-wi-video-play]');
      if (!video || !button) return;
      button.hidden = !video.paused;
      button.setAttribute('aria-label', video.ended ? 'Replay product video' : 'Play product video');
    };

    const startVideo = (item) => {
      if (!item || item.hidden) return;
      const video = item.querySelector('video');
      if (!video) return;

      setVideoFeedback(item);
      // A hidden slide starts with preload="none". Upgrade only the video
      // the customer selects; play() initiates fetching if necessary.
      video.preload = 'metadata';
      if (video.ended) {
        try { video.currentTime = 0; } catch (_) { /* Nonseekable stream. */ }
      }

      try {
        const result = video.play();
        if (result && typeof result.catch === 'function') {
          result.catch((error) => {
            if (item.hidden || error?.name === 'AbortError') return;
            syncVideoPlayButton(item);
            if (error?.name !== 'NotAllowedError') {
              setVideoFeedback(item, 'Video playback failed. Tap play to try again.');
              console.warn('[WI Product Gallery] Video playback failed.', error);
            }
          });
        }
      } catch (error) {
        syncVideoPlayButton(item);
        setVideoFeedback(item, 'Video playback failed. Tap play to try again.');
        console.warn('[WI Product Gallery] Video playback failed.', error);
      }
    };

    videoMediaItems.forEach((item) => {
      const video = item.querySelector('video');
      if (!video) return;

      item.querySelector('[data-wi-video-play]')?.addEventListener('click', (event) => {
        event.preventDefault();
        startVideo(item);
      });
      video.addEventListener('play', () => {
        setVideoFeedback(item);
        syncVideoPlayButton(item);
      });
      video.addEventListener('pause', () => syncVideoPlayButton(item));
      video.addEventListener('ended', () => syncVideoPlayButton(item));
      video.addEventListener('error', () => {
        if (!item.hidden) {
          setVideoFeedback(item, 'This video could not be loaded. Please try again.');
          syncVideoPlayButton(item);
        }
      });
      syncVideoPlayButton(item);
    });

    const showMedia = (requested, { playVideo = false } = {}) => {
      if (!thumbnails.length) return;

      activeIndex =
        (requested +
          thumbnails.length) %
        thumbnails.length;

      const thumb = thumbnails[activeIndex];
      const id = thumb.dataset.mediaId;
      let selectedMedia = null;

      mediaItems.forEach((item) => {
        const active = item.dataset.mediaId === id;
        const video = item.querySelector('video');

        if (!active && video) {
          video.pause();
          // Return to the poster when revisiting a video.
          if (video.readyState > 0) {
            try { video.currentTime = 0; } catch (_) { /* Nonseekable stream. */ }
          }
          setVideoFeedback(item);
          syncVideoPlayButton(item);
        }

        item.hidden = !active;
        item.classList.toggle('is-active', active);
        if (active) selectedMedia = item;
      });

      thumbnails.forEach((item, index) => {
        const active = index === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });

      progress.forEach((item, index) =>
        item.classList.toggle('is-active', index === activeIndex)
      );

      keepThumbnailVisible(thumb);

      if (selectedMedia?.dataset.mediaType === 'video') {
        const video = selectedMedia.querySelector('video');
        if (video) video.preload = 'metadata';
        if (playVideo) startVideo(selectedMedia);
        else syncVideoPlayButton(selectedMedia);
      }
    };

    thumbnails.forEach((item, index) =>
      item.addEventListener('click', () => showMedia(index, { playVideo: true }))
    );

    root.querySelector('[data-wi-gallery-prev]')?.addEventListener('click', () =>
      showMedia(activeIndex - 1, { playVideo: true })
    );

    root.querySelector('[data-wi-gallery-next]')?.addEventListener('click', () =>
      showMedia(activeIndex + 1, { playVideo: true })
    );

    root
      .querySelector(
        '[data-wi-thumb-prev]'
      )
      ?.addEventListener(
        'click',
        () =>
          track?.scrollBy({
            left: -Math.max(
              100,
              track.clientWidth * 0.72
            ),
            behavior: reducedMotion
              ? 'auto'
              : 'smooth'
          })
      );

    root
      .querySelector(
        '[data-wi-thumb-next]'
      )
      ?.addEventListener(
        'click',
        () =>
          track?.scrollBy({
            left: Math.max(
              100,
              track.clientWidth * 0.72
            ),
            behavior: reducedMotion
              ? 'auto'
              : 'smooth'
          })
      );

    track?.addEventListener(
      'scroll',
      updateThumbArrows,
      {
        passive: true
      }
    );

    updateThumbArrows();

    let startX = null;

    stage?.addEventListener(
      'touchstart',
      (event) => {
        startX = event.target.closest(
          'video'
        )
          ? null
          : event.changedTouches[0]
              .clientX;
      },
      {
        passive: true
      }
    );

    stage?.addEventListener(
      'touchend',
      (event) => {
        if (startX === null) return;

        const distance =
          event.changedTouches[0]
            .clientX - startX;

        if (
          Math.abs(distance) > 45
        ) {
          showMedia(
            activeIndex +
              (distance < 0 ? 1 : -1)
          );
        }

        startX = null;
      },
      {
        passive: true
      }
    );

    const quantity = root.querySelector(
      '[data-wi-quantity]'
    );

    const buttonPrice = root.querySelector(
      '[data-wi-button-price]'
    );

    let unitPrice = Number(
      config.unitPrice || 0
    );

    const setQuantity = (value) => {
      if (!quantity) return;

      const next = Math.max(
        1,
        parseInt(value, 10) || 1
      );

      quantity.value = next;

      if (
        buttonPrice &&
        unitPrice > 0
      ) {
        buttonPrice.textContent =
          ` · ${formatMoney(
            unitPrice * next
          )}`;
      }
    };

    root
      .querySelector('[data-wi-minus]')
      ?.addEventListener(
        'click',
        () =>
          setQuantity(
            Number(
              quantity?.value || 1
            ) - 1
          )
      );

    root
      .querySelector('[data-wi-plus]')
      ?.addEventListener(
        'click',
        () =>
          setQuantity(
            Number(
              quantity?.value || 1
            ) + 1
          )
      );

    quantity?.addEventListener(
      'change',
      () => setQuantity(quantity.value)
    );

    const variantSelect =
      root.querySelector(
        '[data-wi-variant]'
      );

    const variantPicker =
      root.querySelector(
        '[data-wi-variant-picker]'
      );

    const optionChoices = Array.from(
      root.querySelectorAll(
        '[data-wi-option-value]'
      )
    );

    const optionGroups = Array.from(
      root.querySelectorAll(
        '[data-wi-option-group]'
      )
    );

    const derivedPicker =
      variantPicker?.dataset
        .wiDerivedPicker === 'true';

    const variantData =
      Array.isArray(config.variants)
        ? config.variants
        : [];

    const splitVariantTitle = (
      title
    ) =>
      String(title || '')
        .split(' / ')
        .map((value) => value.trim());

    const getVariantValues = (
      variant
    ) =>
      derivedPicker
        ? splitVariantTitle(
            variant?.title
          )
        : Array.from(
            variant?.options || []
          ).map((value) =>
            String(value)
          );

    const variantRows = variantData.map(
      (variant) => ({
        variant,
        values:
          getVariantValues(variant)
      })
    );

    const availableVariantRows =
      variantRows.filter(
        (row) =>
          row.variant.available
      );

    const optionKey = '\u001f';

    const exactAvailableVariantMap =
      new Map();

    const firstAvailableByPrefix =
      Array.from(
        {
          length: Math.max(
            1,
            optionGroups.length
          )
        },
        () => new Map()
      );

    const availabilityByPosition =
      Array.from(
        {
          length: Math.max(
            1,
            optionGroups.length
          )
        },
        () => new Map()
      );

    availableVariantRows.forEach(
      (row) => {
        exactAvailableVariantMap.set(
          row.values.join(optionKey),
          row
        );

        row.values.forEach(
          (value, position) => {
            const exactPrefix =
              row.values
                .slice(0, position + 1)
                .join(optionKey);

            if (
              !firstAvailableByPrefix[
                position
              ].has(exactPrefix)
            ) {
              firstAvailableByPrefix[
                position
              ].set(exactPrefix, row);
            }

            const precedingPrefix =
              row.values
                .slice(0, position)
                .join(optionKey);

            let availableValues =
              availabilityByPosition[
                position
              ].get(precedingPrefix);

            if (!availableValues) {
              availableValues = new Set();

              availabilityByPosition[
                position
              ].set(
                precedingPrefix,
                availableValues
              );
            }

            availableValues.add(value);
          }
        );
      }
    );

    const packBadgeConfig = {
      enabled: Boolean(
        config.packBadges?.enabled
      ),
      superSaver: String(
        config.packBadges?.superSaver ||
          ''
      ),
      mostBought: String(
        config.packBadges?.mostBought ||
          ''
      )
    };

    let selectedOptions = [];

    const getCurrentVariantRow = () =>
      variantRows.find(
        (row) =>
          String(row.variant.id) ===
          String(variantSelect?.value)
      );

    const updateOptionAvailability =
      () => {
        optionChoices.forEach(
          (choice) => {
            const position = Math.max(
              0,
              Number(
                choice.dataset
                  .optionPosition || 1
              ) - 1
            );

            const value =
              choice.dataset
                .optionValue || '';

            const precedingPrefix =
              selectedOptions
                .slice(0, position)
                .join(optionKey);

            const available =
              availabilityByPosition[
                position
              ]
                ?.get(precedingPrefix)
                ?.has(value) === true;

            choice.disabled =
              !available;

            choice.setAttribute(
              'aria-disabled',
              available
                ? 'false'
                : 'true'
            );
          }
        );
      };

    const badgeElements = new Map();

    const removePackBadges = () => {
      optionChoices.forEach((choice) =>
        choice.classList.remove(
          'has-pack-badge',
          'has-pack-badge--super',
          'has-pack-badge--popular'
        )
      );

      optionGroups.forEach((group) =>
        group.classList.remove(
          'has-dynamic-badges'
        )
      );

      badgeElements.forEach((badge) => {
        badge.hidden = true;
      });
    };

    const addPackBadge = (
      choice,
      label,
      type
    ) => {
      if (!choice || !label) return;

      let badge =
        badgeElements.get(type);

      if (!badge) {
        badge =
          document.createElement('span');

        badge.className =
          `wi-pg__variant-badge wi-pg__variant-badge--${type}`;

        badge.dataset.wiPackBadge =
          type;

        badge.setAttribute(
          'aria-hidden',
          'true'
        );

        badgeElements.set(
          type,
          badge
        );
      }

      if (
        badge.textContent !== label
      ) {
        badge.textContent = label;
      }

      if (
        badge.parentElement !== choice
      ) {
        choice.appendChild(badge);
      }

      badge.hidden = false;

      choice.classList.add(
        'has-pack-badge',
        `has-pack-badge--${type}`
      );
    };

    const getPricedChoicesForGroup = (
      group
    ) => {
      if (!group) return [];

      const position = Math.max(
        0,
        Number(
          group.dataset.optionPosition ||
            1
        ) - 1
      );

      const choices = Array.from(
        group.querySelectorAll(
          '[data-wi-option-value]'
        )
      ).filter(
        (choice) => !choice.disabled
      );

      const minimumPriceByValue =
        new Map();

      availableVariantRows.forEach(
        (row) => {
          const matchesOtherSelections =
            row.values.every(
              (
                rowValue,
                rowIndex
              ) =>
                rowIndex === position ||
                selectedOptions[
                  rowIndex
                ] == null ||
                rowValue ===
                  selectedOptions[
                    rowIndex
                  ]
            );

          if (
            !matchesOtherSelections
          ) {
            return;
          }

          const value =
            row.values[position];

          const price = Number(
            row.variant.price || 0
          );

          if (
            !Number.isFinite(price)
          ) {
            return;
          }

          const current =
            minimumPriceByValue.get(
              value
            );

          if (
            current == null ||
            price < current
          ) {
            minimumPriceByValue.set(
              value,
              price
            );
          }
        }
      );

      return choices
        .map((choice, index) => {
          const price =
            minimumPriceByValue.get(
              choice.dataset
                .optionValue || ''
            );

          return price == null
            ? null
            : {
                choice,
                index,
                price
              };
        })
        .filter(Boolean)
        .sort(
          (a, b) =>
            a.price - b.price ||
            a.index - b.index
        );
    };

    const groupLooksCommercial = (
      group
    ) => {
      if (
        !group ||
        group.classList.contains(
          'is-color'
        ) ||
        group.classList.contains(
          'is-size'
        )
      ) {
        return false;
      }

      if (
        group.classList.contains(
          'is-pack'
        ) ||
        group.classList.contains(
          'is-offer'
        )
      ) {
        return true;
      }

      const labels = Array.from(
        group.querySelectorAll(
          '[data-wi-option-value]'
        )
      )
        .map(
          (choice) =>
            `${choice.dataset.optionValue || ''} ${choice.dataset.displayValue || ''}`
        )
        .join(' ');

      return /\b(pack|packs|pair|pairs|combo|offer|bundle|bundles|set|sets|piece|pieces|pcs|quantity|qty)\b/i.test(
        labels
      );
    };

    const findBadgeGroup = () => {
      const explicit =
        optionGroups.find((group) =>
          group.classList.contains(
            'is-pack'
          )
        ) ||
        optionGroups.find((group) =>
          group.classList.contains(
            'is-offer'
          )
        );

      if (explicit) return explicit;

      const valueDriven =
        optionGroups.find((group) =>
          groupLooksCommercial(group)
        );

      if (valueDriven) {
        return valueDriven;
      }

      if (
        optionGroups.length === 1
      ) {
        const onlyGroup =
          optionGroups[0];

        if (
          !onlyGroup.classList.contains(
            'is-color'
          ) &&
          !onlyGroup.classList.contains(
            'is-size'
          )
        ) {
          const priced =
            getPricedChoicesForGroup(
              onlyGroup
            );

          const uniquePrices =
            new Set(
              priced.map(
                (item) => item.price
              )
            );

          if (
            priced.length >= 2 &&
            (groupLooksCommercial(
              onlyGroup
            ) ||
              uniquePrices.size > 1)
          ) {
            return onlyGroup;
          }
        }
      }

      return null;
    };

    const updatePackBadges = () => {
      removePackBadges();

      if (
        !packBadgeConfig.enabled
      ) {
        return;
      }

      const badgeGroup =
        findBadgeGroup();

      if (!badgeGroup) return;

      const pricedChoices =
        getPricedChoicesForGroup(
          badgeGroup
        );

      if (
        pricedChoices.length < 2
      ) {
        return;
      }

      badgeGroup.classList.add(
        'has-dynamic-badges'
      );

      const superSaver =
        pricedChoices[
          pricedChoices.length - 1
        ];

      addPackBadge(
        superSaver.choice,
        packBadgeConfig.superSaver,
        'super'
      );

      let popularIndex = 0;

      if (
        pricedChoices.length === 3
      ) {
        popularIndex = 1;
      } else if (
        pricedChoices.length >= 4
      ) {
        popularIndex = 1;
      }

      let mostBought =
        pricedChoices[popularIndex];

      if (
        mostBought === superSaver
      ) {
        mostBought =
          pricedChoices[0];
      }

      addPackBadge(
        mostBought.choice,
        packBadgeConfig.mostBought,
        'popular'
      );
    };

    const syncOptionUI = () => {
      const current =
        getCurrentVariantRow();

      if (!current) return;

      selectedOptions = [
        ...current.values
      ];

      optionChoices.forEach(
        (choice) => {
          const position = Math.max(
            0,
            Number(
              choice.dataset
                .optionPosition || 1
            ) - 1
          );

          const active =
            choice.dataset.optionValue ===
            selectedOptions[position];

          choice.classList.toggle(
            'is-active',
            active
          );

          choice.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );
        }
      );

      optionGroups.forEach(
        (group) => {
          const position = Math.max(
            0,
            Number(
              group.dataset
                .optionPosition || 1
            ) - 1
          );

          const activeChoice =
            optionChoices.find(
              (choice) =>
                Number(
                  choice.dataset
                    .optionPosition ||
                    1
                ) -
                  1 ===
                  position &&
                choice.dataset
                  .optionValue ===
                  selectedOptions[
                    position
                  ]
            );

          const label =
            group.querySelector(
              '[data-wi-selected-option]'
            );

          if (label) {
            label.textContent =
              activeChoice?.dataset
                .displayValue ||
              selectedOptions[
                position
              ] ||
              '';
          }
        }
      );

      updateOptionAvailability();
      updatePackBadges();
    };

    const handleVariantChange = (
      event
    ) => {
      const option =
        event.target.options[
          event.target.selectedIndex
        ];

      if (!option) return;

      const price = Number(
        option.dataset.priceRaw || 0
      );

      const compare = Number(
        option.dataset.compareRaw || 0
      );

      unitPrice = price;

      const priceTargets = [
        ...root.querySelectorAll(
          '[data-wi-price],[data-wi-mobile-price]'
        )
      ];

      priceTargets.forEach(
        (element) => {
          element.textContent =
            option.dataset.price ||
            formatMoney(price);
        }
      );

      const compareEl =
        root.querySelector(
          '[data-wi-compare]'
        );

      const discount =
        root.querySelector(
          '[data-wi-discount]'
        );

      if (compareEl && discount) {
        const sale = compare > price;

        compareEl.hidden = !sale;
        discount.hidden = !sale;

        if (sale) {
          compareEl.textContent =
            option.dataset.compare ||
            formatMoney(compare);

          discount.textContent =
            `SAVE ${Math.round(
              ((compare - price) /
                compare) *
                100
            )}%`;
        }
      }

      const mediaThumb =
        thumbnails.find(
          (item) =>
            item.dataset.mediaId ===
            option.dataset.mediaId
        );

      if (mediaThumb) {
        showMedia(
          thumbnails.indexOf(
            mediaThumb
          )
        );
      }

      syncOptionUI();

      setQuantity(
        quantity?.value || 1
      );

      document.dispatchEvent(
        new CustomEvent(
          'wi:product-variant-change',
          {
            detail: {
              price,
              formattedPrice:
                option.dataset.price,
              variantId:
                event.target.value
            }
          }
        )
      );
    };

    variantSelect?.addEventListener(
      'change',
      handleVariantChange
    );

    optionChoices.forEach((choice) =>
      choice.addEventListener(
        'click',
        () => {
          if (
            !variantSelect ||
            choice.disabled
          ) {
            return;
          }

          const position = Math.max(
            0,
            Number(
              choice.dataset
                .optionPosition || 1
            ) - 1
          );

          const requestedValue =
            choice.dataset
              .optionValue || '';

          const requested = [
            ...selectedOptions
          ];

          requested[position] =
            requestedValue;

          let target =
            exactAvailableVariantMap.get(
              requested.join(optionKey)
            );

          if (!target) {
            const requestedPrefix =
              requested
                .slice(
                  0,
                  position + 1
                )
                .join(optionKey);

            target =
              firstAvailableByPrefix[
                position
              ]?.get(requestedPrefix);
          }

          if (!target) return;

          variantSelect.value =
            String(
              target.variant.id
            );

          variantSelect.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }
      )
    );

    syncOptionUI();

    root.wiCleanup = () => {
      window.removeEventListener(
        'scroll',
        requestNavigationUpdate
      );

      window.removeEventListener(
        'resize',
        handleNavigationResize
      );

      window.removeEventListener(
        'scrollend',
        handleScrollEnd
      );

      window.removeEventListener(
        'wheel',
        handleManualNavigation
      );

      window.removeEventListener(
        'touchstart',
        handleManualNavigation
      );

      window.removeEventListener(
        'keydown',
        handleNavigationKey
      );

      document.removeEventListener(
        'shopify:section:load',
        handleSectionStructureChange
      );

      document.removeEventListener(
        'shopify:section:unload',
        handleSectionStructureChange
      );

      document.removeEventListener(
        'wi:reviews-summary',
        handleReviewsSummary
      );

      root.removeEventListener(
        'click',
        handleStickySubmitClick,
        true
      );

      if (
        navigationFrame !== null
      ) {
        cancelAnimationFrame(
          navigationFrame
        );
      }

      if (indicatorFrame !== null) {
        cancelAnimationFrame(
          indicatorFrame
        );
      }

      if (
        navigationLockTimer !== null
      ) {
        clearTimeout(
          navigationLockTimer
        );
      }

      if (
        stickyCartResetTimer !== null
      ) {
        clearTimeout(
          stickyCartResetTimer
        );
      }

      sticky?.classList.remove(
        'is-fixed'
      );

      sticky?.style.removeProperty(
        'top'
      );

      sticky?.style.removeProperty(
        'z-index'
      );
    };
  };

  window.WIProductGalleryInitialize =
    initialize;

  document
    .querySelectorAll(
      '[data-wi-product-gallery]'
    )
    .forEach(initialize);

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      initialize(
        event.target.querySelector?.(
          '[data-wi-product-gallery]'
        )
      )
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) =>
      event.target
        .querySelector?.(
          '[data-wi-product-gallery]'
        )
        ?.wiCleanup?.()
  );
})();